export const permissions =
{
  "CmsLookup": {
    Cms_Lookup: 'CmsLookup',
    Content_Management: 'ContentManagement',

    // Content entry
    Cms_ContentEntryScreen: 'CmsContentEntryScreen',
    Cms_ContentEntryViewList: 'CmsContentEntryViewList',
    Cms_ContentEntryViewInfo: 'CmsContentEntryViewInfo',
    Cms_ContentEntryAdd: 'CmsContentEntryAdd',
    Cms_ContentEntryUpdate: 'CmsContentEntryUpdate',
    Cms_ContentEntryUpdateStatus: 'CmsContentEntryUpdateStatus',

    // Content type
    Cms_ContentTypeScreen: 'CmsContentTypeScreen',
    Cms_ContentTypeViewList: 'CmsContentTypeViewList',
    Cms_ContentTypeViewInfo: 'CmsContentTypeViewInfo',
    Cms_ContentTypeAdd: 'CmsContentTypeAdd',
    Cms_ContentTypeUpdate: 'CmsContentTypeUpdate',
    Cms_ContentTypeUpdateStatus: 'CmsContentTypeUpdateStatus',

    // Story
    Swf_StoryScreen: 'SwfStoryScreen',
    Swf_StoryViewList: 'SwfStoryViewList',
    Swf_StoryViewInfo: 'SwfStoryViewInfo',
    Swf_StoryAdd: 'SwfStoryAdd',
    Swf_StoryUpdate: 'SwfStoryUpdate',
    Swf_StoryUpdateStatus: 'SwfStoryUpdateStatus',

    // Story type
    Swf_StoryTypeScreen: 'SwfStoryTypeScreen',
    Swf_StoryTypeViewList: 'SwfStoryTypeViewList',
    Swf_StoryTypeViewInfo: 'SwfStoryTypeViewInfo',
    Swf_StoryTypeAdd: 'SwfStoryTypeAdd',
    Swf_StoryTypeUpdate: 'SwfStoryTypeUpdate',
    Swf_StoryTypeUpdateStatus: 'SwfStoryTypeUpdateStatus',
  },

  "EvlLookup": {
    Evl_Lookup: 'EvlLookup',
    Evaluation: 'Evaluation',

    // Evaluation criteria
    Evl_EvaluationCriteriaScreen: 'EvlEvaluationCriteriaScreen',
    Evl_EvaluationCriteriaViewList: 'EvlEvaluationCriteriaViewList',
    Evl_EvaluationCriteriaViewInfo: 'EvlEvaluationCriteriaViewInfo',
    Evl_EvaluationCriteriaAdd: 'EvlEvaluationCriteriaAdd',
    Evl_EvaluationCriteriaUpdate: 'EvlEvaluationCriteriaUpdate',
    Evl_EvaluationCriteriaUpdateStatus: 'EvlEvaluationCriteriaUpdateStatus',

    // Evaluation scale
    Evl_EvaluationScaleScreen: 'EvlEvaluationScaleScreen',
    Evl_EvaluationScaleViewList: 'EvlEvaluationScaleViewList',
    Evl_EvaluationScaleViewInfo: 'EvlEvaluationScaleViewInfo',
    Evl_EvaluationScaleAdd: 'EvlEvaluationScaleAdd',
    Evl_EvaluationScaleUpdate: 'EvlEvaluationScaleUpdate',
    Evl_EvaluationScaleUpdateStatus: 'EvlEvaluationScaleUpdateStatus',

    // Evaluation subject
    Evl_EvaluationSubjectScreen: 'EvlEvaluationSubjectScreen',
    Evl_EvaluationSubjectViewList: 'EvlEvaluationSubjectViewList',
    Evl_EvaluationSubjectViewInfo: 'EvlEvaluationSubjectViewInfo',
    Evl_EvaluationSubjectAdd: 'EvlEvaluationSubjectAdd',
    Evl_EvaluationSubjectUpdate: 'EvlEvaluationSubjectUpdate',
    Evl_EvaluationSubjectUpdateStatus: 'EvlEvaluationSubjectUpdateStatus',

    // Subject evaluation criteria
    Evl_SubjectEvaluationCriteriaScreen: 'EvlSubjectEvaluationCriteriaScreen',
    Evl_SubjectEvaluationCriteriaViewList: 'EvlSubjectEvaluationCriteriaViewList',
    Evl_SubjectEvaluationCriteriaViewInfo: 'EvlSubjectEvaluationCriteriaViewInfo',
    Evl_SubjectEvaluationCriteriaAdd: 'EvlSubjectEvaluationCriteriaAdd',
    Evl_SubjectEvaluationCriteriaUpdate: 'EvlSubjectEvaluationCriteriaUpdate',
    Evl_SubjectEvaluationCriteriaUpdateStatus: 'EvlSubjectEvaluationCriteriaUpdateStatus',
  },

  "HcmLookup": {
    Hcm_Lookup: 'HcmLookup',
    Human_Resources: 'HumanResources',

    // Department
    Hcm_DepartmentScreen: 'HcmDepartmentScreen',
    Hcm_DepartmentViewList: 'HcmDepartmentViewList',
    Hcm_DepartmentViewInfo: 'HcmDepartmentViewInfo',
    Hcm_DepartmentAdd: 'HcmDepartmentAdd',
    Hcm_DepartmentUpdate: 'HcmDepartmentUpdate',
    Hcm_DepartmentUpdateStatus: 'HcmDepartmentUpdateStatus',

    // Employee
    Hcm_EmployeeScreen: 'HcmEmployeeScreen',
    Hcm_EmployeeViewList: 'HcmEmployeeViewList',
    Hcm_EmployeeViewInfo: 'HcmEmployeeViewInfo',
    Hcm_EmployeeAdd: 'HcmEmployeeAdd',
    Hcm_EmployeeUpdate: 'HcmEmployeeUpdate',
    Hcm_EmployeeUpdateStatus: 'HcmEmployeeUpdateStatus',

    //Designation
    Hcm_DesignationScreen: 'HcmDesignationScreen',
    Hcm_DesignationViewList: 'HcmDesignationViewList',
    Hcm_DesignationViewInfo: 'HcmDesignationViewInfo',
    Hcm_DesignationAdd: 'HcmDesignationAdd',
    Hcm_DesignationUpdate: 'HcmDesignationUpdate',
    Hcm_DesignationUpdateStatus: 'HcmDesignationUpdateStatus',

    // Attendance Machine
    Hcm_AttendanceMachineScreen: 'HcmAttendanceMachineScreen',
    Hcm_AttendanceMachineViewList: 'HcmAttendanceMachineViewList',
    Hcm_AttendanceMachineViewInfo: 'HcmAttendanceMachineViewInfo',
    Hcm_AttendanceMachineAdd: 'HcmAttendanceMachineAdd',
    Hcm_AttendanceMachineUpdate: 'HcmAttendanceMachineUpdate',
    Hcm_AttendanceMachineUpdateStatus: 'HcmAttendanceMachineUpdateStatus',

    // Attendance Schedule
    Hcm_AttendanceScheduleScreen: 'HcmAttendanceScheduleScreen',
    Hcm_AttendanceScheduleViewList: 'HcmAttendanceScheduleViewList',
    Hcm_AttendanceScheduleViewInfo: 'HcmAttendanceScheduleViewInfo',
    Hcm_AttendanceScheduleAdd: 'HcmAttendanceScheduleAdd',
    Hcm_AttendanceScheduleUpdate: 'HcmAttendanceScheduleUpdate',
    Hcm_AttendanceScheduleUpdateStatus: 'HcmAttendanceScheduleUpdateStatus',

    // Attendance Transaction
    Hcm_AttendanceTransactionScreen: 'HcmAttendanceTransactionScreen',
    Hcm_AttendanceTransactionViewList: 'HcmAttendanceTransactionViewList',
    Hcm_AttendanceTransactionViewInfo: 'HcmAttendanceTransactionViewInfo',
    Hcm_AttendanceTransactionAdd: 'HcmAttendanceTransactionAdd',
    Hcm_AttendanceTransactionUpdate: 'HcmAttendanceTransactionUpdate',
    Hcm_AttendanceTransactionUpdateStatus: 'HcmAttendanceTransactionUpdateStatus',
  },

  "SysLookup": {
    Sys_Lookup: "SysLookup",

    User_Management: "UserManagement",

    // Authority
    Sys_AuthorityScreen: "SysAuthorityScreen",
    Sys_AuthorityViewList: "SysAuthorityViewList",
    Sys_AuthorityViewInfo: "SysAuthorityViewInfo",
    Sys_AuthorityAdd: "SysAuthorityAdd",
    Sys_AuthorityUpdate: "SysAuthorityUpdate",
    Sys_AuthorityUpdateStatus: "SysAuthorityUpdateStatus",

    // Authority type
    Sys_AuthorityTypeScreen: "SysAuthorityTypeScreen",
    Sys_AuthorityTypeViewList: "SysAuthorityTypeViewList",
    Sys_AuthorityTypeViewInfo: "SysAuthorityTypeViewInfo",
    Sys_AuthorityTypeAdd: "SysAuthorityTypeAdd",
    Sys_AuthorityTypeUpdate: "SysAuthorityTypeUpdate",
    Sys_AuthorityTypeUpdateStatus: "SysAuthorityTypeUpdateStatus",

    // Role
    Sys_RoleScreen: "SysRoleScreen",
    Sys_RoleViewList: "SysRoleViewList",
    Sys_RoleViewInfo: "SysRoleViewInfo",
    Sys_RoleAdd: "SysRoleAdd",
    Sys_RoleUpdate: "SysRoleUpdate",
    Sys_RoleUpdateStatus: "SysRoleUpdateStatus",
    Sys_RoleClone: "SysRoleClone",

    // Role authority
    Sys_RoleAuthorityScreen: "SysRoleAuthorityScreen",
    Sys_RoleAuthorityViewList: "SysRoleAuthorityViewList",
    Sys_RoleAuthorityViewInfo: "SysRoleAuthorityViewInfo",
    Sys_RoleAuthorityAdd: "SysRoleAuthorityAdd",
    Sys_RoleAuthorityUpdate: "SysRoleAuthorityUpdate",
    Sys_RoleAuthorityUpdateStatus: "SysRoleAuthorityUpdateStatus",

    // User
    Sys_UserScreen: "SysUserScreen",
    Sys_UserViewList: "SysUserViewList",
    Sys_UserViewInfo: "SysUserViewInfo",
    Sys_UserAdd: "SysUserAdd",
    Sys_UserUpdate: "SysUserUpdate",
    Sys_UserUpdateStatus: "SysUserUpdateStatus",

    // User role
    Sys_UserRoleScreen: "SysUserRoleScreen",
    Sys_UserRoleViewList: "SysUserRoleViewList",
    Sys_UserRoleViewInfo: "SysUserRoleViewInfo",
    Sys_UserRoleAdd: "SysUserRoleAdd",
    Sys_UserRoleUpdate: "SysUserRoleUpdate",
    Sys_UserRoleUpdateStatus: "SysUserRoleUpdateStatus",

    /*********************************************************/
    System_Configutation: "SystemConfigutation",

    // Configuration
    Sys_ConfigurationScreen: "SysConfigurationScreen",
    Sys_ConfigurationViewList: "SysConfigurationViewList",
    Sys_ConfigurationViewInfo: "SysConfigurationViewInfo",
    Sys_ConfigurationAdd: "SysConfigurationAdd",
    Sys_ConfigurationUpdate: "SysConfigurationUpdate",
    Sys_ConfigurationUpdateStatus: "SysConfigurationUpdateStatus",

    // Country
    Sys_CountryScreen: "SysCountryScreen",
    Sys_CountryViewList: "SysCountryViewList",
    Sys_CountryViewInfo: "SysCountryViewInfo",
    Sys_CountryAdd: "SysCountryAdd",
    Sys_CountryUpdate: "SysCountryUpdate",
    Sys_CountryUpdateStatus: "SysCountryUpdateStatus",

    // Module
    Sys_ModuleScreen: "SysModuleScreen",
    Sys_ModuleViewList: "SysModuleViewList",
    Sys_ModuleViewInfo: "SysModuleViewInfo",
    Sys_ModuleAdd: "SysModuleAdd",
    Sys_ModuleUpdate: "SysModuleUpdate",
    Sys_ModuleUpdateStatus: "SysModuleUpdateStatus",

    // Nationality
    Sys_NationalityScreen: "SysNationalityScreen",
    Sys_NationalityViewList: "SysNationalityViewList",
    Sys_NationalityViewInfo: "SysNationalityViewInfo",
    Sys_NationalityAdd: "SysNationalityAdd",
    Sys_NationalityUpdate: "SysNationalityUpdate",
    Sys_NationalityUpdateStatus: "SysNationalityUpdateStatus",

    /*********************************************************/
    Contact_Management: "ContactManagement",

    // Contact detail
    Sys_ContactDetailScreen: "SysContactDetailScreen",
    Sys_ContactDetailViewList: "SysContactDetailViewList",
    Sys_ContactDetailViewInfo: "SysContactDetailViewInfo",
    Sys_ContactDetailAdd: "SysContactDetailAdd",
    Sys_ContactDetailUpdate: "SysContactDetailUpdate",
    Sys_ContactDetailUpdateStatus: "SysContactDetailUpdateStatus",

    // Contact info
    Sys_ContactInfoScreen: "SysContactInfoScreen",
    Sys_ContactInfoViewList: "SysContactInfoViewList",
    Sys_ContactInfoViewInfo: "SysContactInfoViewInfo",
    Sys_ContactInfoAdd: "SysContactInfoAdd",
    Sys_ContactInfoUpdate: "SysContactInfoUpdate",
    Sys_ContactInfoUpdateStatus: "SysContactInfoUpdateStatus",

    // Contact type
    Sys_ContactTypeScreen: "SysContactTypeScreen",
    Sys_ContactTypeViewList: "SysContactTypeViewList",
    Sys_ContactTypeViewInfo: "SysContactTypeViewInfo",
    Sys_ContactTypeAdd: "SysContactTypeAdd",
    Sys_ContactTypeUpdate: "SysContactTypeUpdate",
    Sys_ContactTypeUpdateStatus: "SysContactTypeUpdateStatus",
  },

  "SwfLookup": {
    Swf_Lookup: "SwfLookup",

    Geographical_Info: "GeographicalInfo",

    // Area
    Swf_AreaScreen: "SwfAreaScreen",
    Swf_AreaViewList: "SwfAreaViewList",
    Swf_AreaViewInfo: "SwfAreaViewInfo",
    Swf_AreaAdd: "SwfAreaAdd",
    Swf_AreaUpdate: "SwfAreaUpdate",
    Swf_AreaUpdateStatus: "SwfAreaUpdateStatus",

    // Area category
    Swf_AreaCategoryScreen: "SwfAreaCategoryScreen",
    Swf_AreaCategoryViewList: "SwfAreaCategoryViewList",
    Swf_AreaCategoryViewInfo: "SwfAreaCategoryViewInfo",
    Swf_AreaCategoryAdd: "SwfAreaCategoryAdd",
    Swf_AreaCategoryUpdate: "SwfAreaCategoryUpdate",
    Swf_AreaCategoryUpdateStatus: "SwfAreaCategoryUpdateStatus",

    // Area coordinates
    Swf_AreaCoordinatesScreen: "SwfAreaCoordinatesScreen",
    Swf_AreaCoordinatesViewList: "SwfAreaCoordinatesViewList",
    Swf_AreaCoordinatesViewInfo: "SwfAreaCoordinatesViewInfo",
    Swf_AreaCoordinatesAdd: "SwfAreaCoordinatesAdd",
    Swf_AreaCoordinatesUpdate: "SwfAreaCoordinatesUpdate",
    Swf_AreaCoordinatesUpdateStatus: "SwfAreaCoordinatesUpdateStatus",

    // Location
    Swf_LocationScreen: "SwfLocationScreen",
    Swf_LocationViewList: "SwfLocationViewList",
    Swf_LocationViewInfo: "SwfLocationViewInfo",
    Swf_LocationAdd: "SwfLocationAdd",
    Swf_LocationUpdate: "SwfLocationUpdate",
    Swf_LocationUpdateStatus: "SwfLocationUpdateStatus",

    // Location category
    Swf_LocationCategoryScreen: "SwfLocationCategoryScreen",
    Swf_LocationCategoryViewList: "SwfLocationCategoryViewList",
    Swf_LocationCategoryViewInfo: "SwfLocationCategoryViewInfo",
    Swf_LocationCategoryAdd: "SwfLocationCategoryAdd",
    Swf_LocationCategoryUpdate: "SwfLocationCategoryUpdate",
    Swf_LocationCategoryUpdateStatus: "SwfLocationCategoryUpdateStatus",

    // Section
    Swf_SectionScreen: "SwfSectionScreen",
    Swf_SectionViewList: "SwfSectionViewList",
    Swf_SectionViewInfo: "SwfSectionViewInfo",
    Swf_SectionAdd: "SwfSectionAdd",
    Swf_SectionUpdate: "SwfSectionUpdate",
    Swf_SectionUpdateStatus: "SwfSectionUpdateStatus",

    // Section coordinates
    Swf_SectionCoordinatesScreen: "SwfSectionCoordinatesScreen",
    Swf_SectionCoordinatesViewList: "SwfSectionCoordinatesViewList",
    Swf_SectionCoordinatesViewInfo: "SwfSectionCoordinatesViewInfo",
    Swf_SectionCoordinatesAdd: "SwfSectionCoordinatesAdd",
    Swf_SectionCoordinatesUpdate: "SwfSectionCoordinatesUpdate",
    Swf_SectionCoordinatesUpdateStatus: "SwfSectioCoordinatesUpdateStatus",

    /******************************************************************/
    Store_Management: "StoreManagement",

    // Brand
    Swf_BrandScreen: "SwfBrandScreen",
    Swf_BrandViewList: "SwfBrandViewList",
    Swf_BrandViewInfo: "SwfBrandViewInfo",
    Swf_BrandAdd: "SwfBrandAdd",
    Swf_BrandUpdate: "SwfBrandUpdate",
    Swf_BrandUpdateStatus: "SwfBrandUpdateStatus",

    // Industry
    Swf_IndustryScreen: "SwfIndustryScreen",
    Swf_IndustryViewList: "SwfIndustryViewList",
    Swf_IndustryViewInfo: "SwfIndustryViewInfo",
    Swf_IndustryAdd: "SwfIndustryAdd",
    Swf_IndustryUpdate: "SwfIndustryUpdate",
    Swf_IndustryUpdateStatus: "SwfIndustryUpdateStatus",

    // Merchant
    Swf_MerchantScreen: "SwfMerchantScreen",
    Swf_MerchantViewList: "SwfMerchantViewList",
    Swf_MerchantViewInfo: "SwfMerchantViewInfo",
    Swf_MerchantAdd: "SwfMerchantAdd",
    Swf_MerchantUpdate: "SwfMerchantUpdate",
    Swf_MerchantUpdateStatus: "SwfMerchantUpdateStatus",

    // Service
    Swf_ServiceScreen: "SwfServiceScreen",
    Swf_ServiceViewList: "SwfServiceViewList",
    Swf_ServiceViewInfo: "SwfServiceViewInfo",
    Swf_ServiceAdd: "SwfServiceAdd",
    Swf_ServiceUpdate: "SwfServiceUpdate",
    Swf_ServiceUpdateStatus: "SwfServiceUpdateStatus",

    // Service configuration
    Swf_ServiceConfigurationScreen: "SwfServiceConfigurationScreen",
    Swf_ServiceConfigurationViewList: "SwfServiceConfigurationViewList",
    Swf_ServiceConfigurationViewInfo: "SwfServiceConfigurationViewInfo",
    Swf_ServiceConfigurationAdd: "SwfServiceConfigurationAdd",
    Swf_ServiceConfigurationUpdate: "SwfServiceConfigurationUpdate",
    Swf_ServiceConfigurationUpdateStatus: "SwfServiceConfigurationUpdateStatus",

    // Service schedule
    Swf_ServiceScheduleScreen: "SwfServiceScheduleScreen",
    Swf_ServiceScheduleViewList: "SwfServiceScheduleViewList",
    Swf_ServiceScheduleViewInfo: "SwfServiceScheduleViewInfo",
    Swf_ServiceScheduleAdd: "SwfServiceScheduleAdd",
    Swf_ServiceScheduleUpdate: "SwfServiceScheduleUpdate",
    Swf_ServiceScheduleUpdateStatus: "SwfServiceScheduleUpdateStatus",

    // Service status
    Swf_ServiceStatusScreen: "SwfServiceStatusScreen",
    Swf_ServiceStatusViewList: "SwfServiceStatusViewList",
    Swf_ServiceStatusViewInfo: "SwfServiceStatusViewInfo",
    Swf_ServiceStatusAdd: "Swf_ServiceStatusAdd",
    Swf_ServiceStatusUpdate: "Swf_ServiceStatusUpdate",
    Swf_ServiceStatusUpdateStatus: "Swf_ServiceStatusUpdateStatus",

    // Service type
    Swf_ServiceTypeScreen: "SwfServiceTypeScreen",
    Swf_ServiceTypeViewList: "SwfServiceTypeViewList",
    Swf_ServiceTypeViewInfo: "SwfServiceTypeViewInfo",
    Swf_ServiceTypeAdd: "SwfServiceTypeAdd",
    Swf_ServiceTypeUpdate: "SwfServiceTypeUpdate",
    Swf_ServiceTypeUpdateStatus: "SwfServiceTypeUpdateStatus",

    // Store
    Swf_StoreScreen: "SwfStoreScreen",
    Swf_StoreViewList: "SwfStoreViewList",
    Swf_StoreViewInfo: "SwfStoreViewInfo",
    Swf_StoreAdd: "SwfStoreAdd",
    Swf_StoreUpdate: "SwfStoreUpdate",
    Swf_StoreUpdateStatus: "SwfStoreUpdateStatus",

    // Store category
    Swf_StoreCategoryScreen: "SwfStoreCategoryScreen",
    Swf_StoreCategoryViewList: "SwfStoreCategoryViewList",
    Swf_StoreCategoryViewInfo: "SwfStoreCategoryViewInfo",
    Swf_StoreCategoryAdd: "SwfStoreCategoryAdd",
    Swf_StoreCategoryUpdate: "SwfStoreCategoryUpdate",
    Swf_StoreCategoryUpdateStatus: "SwfStoreCategoryUpdateStatus",

    // Store contract
    Swf_StoreContractScreen: "SwfStoreContractScreen",
    Swf_StoreContractViewList: "SwfStoreContractViewList",
    Swf_StoreContractViewInfo: "SwfStoreContractViewInfo",
    Swf_StoreContractAdd: "SwfStoreContractAdd",
    Swf_StoreContractUpdate: "SwfStoreContractUpdate",
    Swf_StoreContractUpdateStatus: "SwfStoreContractUpdateStatus",

    // Store type
    Swf_StoreTypeScreen: "SwfStoreTypeScreen",
    Swf_StoreTypeViewList: "SwfStoreTypeViewList",
    Swf_StoreTypeViewInfo: "SwfStoreTypeViewInfo",
    Swf_StoreTypeAdd: "SwfStoreTypeAdd",
    Swf_StoreTypeUpdate: "SwfStoreTypeUpdate",
    Swf_StoreTypeUpdateStatus: "SwfStoreTypeUpdateStatus",

    /**********************************************************/
    Community_Management: "CommunityManagement",

    // Community
    Swf_CommunityScreen: "SwfCommunityScreen",
    Swf_CommunityViewList: "SwfCommunityViewList",
    Swf_CommunityViewInfo: "SwfCommunityViewInfo",
    Swf_CommunityAdd: "SwfCommunityAdd",
    Swf_CommunityUpdate: "SwfCommunityUpdate",
    Swf_CommunityUpdateStatus: "SwfCommunityUpdateStatus",

    // Community category
    Swf_CommunityCategoryScreen: "SwfCommunityCategoryScreen",
    Swf_CommunityCategoryViewList: "SwfCommunityCategoryViewList",
    Swf_CommunityCategoryViewInfo: "SwfCommunityCategoryViewInfo",
    Swf_CommunityCategoryAdd: "SwfCommunityCategoryAdd",
    Swf_CommunityCategoryUpdate: "SwfCommunityCategoryUpdate",
    Swf_CommunityCategoryUpdateStatus: "SwfCommunityCategoryUpdateStatus",

    // Community schedule
    Swf_CommunityScheduleScreen: "SwfCommunityScheduleScreen",
    Swf_CommunityScheduleViewList: "SwfCommunityScheduleViewList",
    Swf_CommunityScheduleViewInfo: "SwfCommunityScheduleViewInfo",
    Swf_CommunityScheduleAdd: "SwfCommunityScheduleAdd",
    Swf_CommunityScheduleUpdate: "SwfCommunityScheduleUpdate",
    Swf_CommunityScheduleUpdateStatus: "SwfCommunityScheduleUpdateStatus",

    // Community sponsor
    Swf_CommunitySponsorScreen: "SwfCommunitySponsorScreen",
    Swf_CommunitySponsorViewList: "SwfCommunitySponsorViewList",
    Swf_CommunitySponsorViewInfo: "SwfCommunitySponsorViewInfo",
    Swf_CommunitySponsorAdd: "SwfCommunitySponsorAdd",
    Swf_CommunitySponsorUpdate: "SwfCommunitySponsorUpdate",
    Swf_CommunitySponsorUpdateStatus: "SwfCommunitySponsorUpdateStatus",

    /*****************************************************************/
    Customer_Management: "CustomerManagement",

    // Customer
    Swf_CustomerScreen: "SwfCustomerScreen",
    Swf_CustomerViewList: "SwfCustomerViewList",
    Swf_CustomerViewInfo: "SwfCustomerViewInfo",
    Swf_CustomerAdd: "SwfCustomerAdd",
    Swf_CustomerUpdate: "SwfCustomerUpdate",
    Swf_CustomerUpdateStatus: "SwfCustomerUpdateStatus",

    /*******************************************************************/
    Service_Booking: "ServiceBooking",

    // Customer service booking
    Swf_CustomerServiceBookingScreen: "SwfCustomerServiceBookingScreen",
    Swf_CustomerServiceBookingViewList: "SwfCustomerServiceBookingViewList",
    Swf_CustomerServiceBookingViewInfo: "SwfCustomerServiceBookingViewInfo",
    Swf_CustomerServiceBookingAdd: "SwfCustomerServiceBookingAdd",
    Swf_CustomerServiceBookingUpdate: "SwfCustomerServiceBookingUpdate",
    Swf_CustomerServiceBookingUpdateStatus: "SwfCustomerServiceBookingUpdateStatus",

    // Customer ticket
    Swf_CustomerTicketScreen: "SwfCustomerTicketScreen",
    Swf_CustomerTicketViewList: "SwfCustomerTicketViewList",
    Swf_CustomerTicketViewInfo: "SwfCustomerTicketViewInfo",
    Swf_CustomerTicketAdd: "SwfCustomerTicketAdd",
    Swf_CustomerTicketUpdate: "SwfCustomerTicketUpdate",
    Swf_CustomerTicketUpdateStatus: "SwfCustomerTicketUpdateStatus",

    /*******************************************************************/
    Event_Management: "EventManagement",

    // Event
    Swf_EventScreen: "SwfEventScreen",
    Swf_EventViewList: "SwfEventViewList",
    Swf_EventViewInfo: "SwfEventViewInfo",
    Swf_EventAdd: "SwfEventAdd",
    Swf_EventUpdate: "SwfEventUpdate",
    Swf_EventUpdateStatus: "SwfEventUpdateStatus",

    // Event Category
    Swf_EventCategoryScreen: "SwfEventCategoryScreen",
    Swf_EventCategoryViewList: "SwfEventCategoryViewList",
    Swf_EventCategoryViewInfo: "SwfEventCategoryViewInfo",
    Swf_EventCategoryAdd: "SwfEventCategoryAdd",
    Swf_EventCategoryUpdate: "SwfEventCategoryUpdate",
    Swf_EventCategoryUpdateStatus: "SwfEventCategoryUpdateStatus",

    // Event Sponsor
    Swf_EventSponsorScreen: "SwfEventSponsorScreen",
    Swf_EventSponsorViewList: "SwfEventSponsorViewList",
    Swf_EventSponsorViewInfo: "SwfEventSponsorViewInfo",
    Swf_EventSponsorAdd: "SwfEventSponsorAdd",
    Swf_EventSponsorUpdate: "SwfEventSponsorUpdate",
    Swf_EventSponsorUpdateStatus: "SwfEventSponsorUpdateStatus",

    // Event Ticket
    Swf_EventTicketScreen: "SwfEventTicketScreen",
    Swf_EventTicketViewList: "SwfEventTicketViewList",
    Swf_EventTicketViewInfo: "SwfEventTicketViewInfo",
    Swf_EventTicketAdd: "SwfEventTicketAdd",
    Swf_EventTicketUpdate: "SwfEventTicketUpdate",
    Swf_EventTicketUpdateStatus: "Swf_EventTicketUpdateStatus",

    // Event Type
    Swf_EventTypeScreen: "SwfEventTypeScreen",
    Swf_EventTypeViewList: "SwfEventTypeViewList",
    Swf_EventTypeViewInfo: "SwfEventTypeViewInfo",
    Swf_EventTypeAdd: "SwfEventTypeAdd",
    Swf_EventTypeUpdate: "SwfEventTypeUpdate",
    Swf_EventTypeUpdateStatus: "Swf_EventTypeUpdateStatus",

    // Promoter
    Swf_PromoterScreen: "SwfPromoterScreen",
    Swf_PromoterViewList: "SwfPromoterViewList",
    Swf_PromoterViewInfo: "SwfPromoterViewInfo",
    Swf_PromoterAdd: "SwfPromoterAdd",
    Swf_PromoterUpdate: "SwfPromoterUpdate",
    Swf_PromoterUpdateStatus: "Swf_PromoterUpdateStatus",

    // Sponsor
    Swf_SponsorScreen: "SwfSponsorScreen",
    Swf_SponsorViewList: "SwfSponsorViewList",
    Swf_SponsorViewInfo: "SwfSponsorViewInfo",
    Swf_SponsorAdd: "SwfSponsorAdd",
    Swf_SponsorUpdate: "SwfSponsorUpdate",
    Swf_SponsorUpdateStatus: "Swf_SponsorUpdateStatus",

    // Sponsorship Type
    Swf_SponsorshipTypeScreen: "SwfSponsorshipTypeScreen",
    Swf_SponsorshipTypeViewList: "SwfSponsorshipTypeViewList",
    Swf_SponsorshipTypeViewInfo: "SwfSponsorshipTypeViewInfo",
    Swf_SponsorshipTypeAdd: "SwfSponsorshipTypeAdd",
    Swf_SponsorshipTypeUpdate: "SwfSponsorshipTypeUpdate",
    Swf_SponsorshipTypeUpdateStatus: "SwfSponsorshipTypeUpdateStatus",

    // Ticket Type
    Swf_TicketTypeScreen: "SwfTicketTypeScreen",
    Swf_TicketTypeViewList: "SwfTicketTypeViewList",
    Swf_TicketTypeViewInfo: "SwfTicketTypeViewInfo",
    Swf_TicketTypeAdd: "SwfTicketTypeAdd",
    Swf_TicketTypeUpdate: "SwfTicketTypeUpdate",
    Swf_TicketTypeUpdateStatus: "SwfTicketTypeUpdateStatus",

    /*****************************************************************/
    Facility_Management: "FacilityManagement",

    // Facility
    Swf_FacilityScreen: "SwfFacilityScreen",
    Swf_FacilityViewList: "SwfFacilityViewList",
    Swf_FacilityViewInfo: "SwfFacilityViewInfo",
    Swf_FacilityAdd: "SwfFacilityAdd",
    Swf_FacilityUpdate: "SwfFacilityUpdate",
    Swf_FacilityUpdateStatus: "SwfFacilityUpdateStatus",

    // Facility Type
    Swf_FacilityTypeScreen: "SwfFacilityTypeScreen",
    Swf_FacilityTypeViewList: "SwfFacilityTypeViewList",
    Swf_FacilityTypeViewInfo: "SwfFacilityTypeViewInfo",
    Swf_FacilityTypeAdd: "SwfFacilityTypeAdd",
    Swf_FacilityTypeUpdate: "SwfFacilityTypeUpdate",
    Swf_FacilityTypeUpdateStatus: "SwfFacilityTypeUpdateStatus",
  },
  "NtfLookup": {
    Ntf_Lookup: 'NtfLookup',
    Notification_Management: 'NotificationManagement',
    // Notification template
    Ntf_NotificationTemplateScreen: 'NtfNotificationTemplateScreen',
    Ntf_NotificationTemplateViewList: 'NtfNotificationTemplateViewList',
    Ntf_NotificationTemplateViewInfo: 'NtfNotificationTemplateViewInfo',
    Ntf_NotificationTemplateAdd: 'NtfNotificationTemplateAdd',
    Ntf_NotificationTemplateUpdate: 'NtfNotificationTemplateUpdate',
    Ntf_NotificationTemplateUpdateStatus: 'NtfNotificationTemplateUpdateStatus',
    // Notification action
    Ntf_NotificationActionScreen: 'NtfNotificationActionScreen',
    Ntf_NotificationActionViewList: 'NtfNotificationActionViewList',
    Ntf_NotificationActionViewInfo: 'NtfNotificationActionViewInfo',
    Ntf_NotificationActionAdd: 'NtfNotificationActionAdd',
    Ntf_NotificationActionUpdate: 'NtfNotificationActionUpdate',
    Ntf_NotificationActionUpdateStatus: 'NtfNotificationActionUpdateStatus',
    // Notification type
    Ntf_NotificationTypeScreen: 'NtfNotificationTypeScreen',
    Ntf_NotificationTypeViewList: 'NtfNotificationTypeViewList',
    Ntf_NotificationTypeViewInfo: 'NtfNotificationTypeViewInfo',
    Ntf_NotificationTypeAdd: 'NtfNotificationTypeAdd',
    Ntf_NotificationTypeUpdate: 'NtfNotificationTypeUpdate',
    Ntf_NotificationTypeUpdateStatus: 'NtfNotificationTypeUpdateStatus',
    // Notification action role
    Ntf_NotificationActionRoleScreen: 'NtfNotificationActionRoleScreen',
    Ntf_NotificationActionRoleViewList: 'NtfNotificationActionRoleViewList',
    Ntf_NotificationActionRoleViewInfo: 'NtfNotificationActionRoleViewInfo',
    Ntf_NotificationActionRoleAdd: 'NtfNotificationActionRoleAdd',
    Ntf_NotificationActionRoleUpdate: 'NtfNotificationActionRoleUpdate',
    Ntf_NotificationActionRoleUpdateStatus: 'NtfNotificationActionRoleUpdateStatus',
  },
  "Evl_Reports": "EvlReports",
  "Evl_Dashboard ": "EvlDashboard",
  "CbmLookup": {
    Cbm_Lookup: 'CbmLookup',
    CashBook_Management: 'CashBookManagement',
    // Transaction template
    Cbm_TransactionScreen: 'CbmTransactionScreen',
      Cbm_TransactionViewList: 'CbmTransactionViewList',
      Cbm_TransactionViewInfo: 'CbmTransactionViewInfo',
      Cbm_TransactionAdd: 'CbmTransactionAdd',
      Cbm_TransactionUpdate: 'CbmTransactionUpdate',
      Cbm_TransactionUpdateStatus: 'CbmTransactionUpdateStatus',
      Cbm_TransactionViewAll: 'CbmTransactionViewAll',
    //CashBook
    Cbm_CashBookScreen:"CbmCashBookScreen",
      Cbm_CashBookViewList:"CbmCashBookViewList",
      Cbm_CashBookViewInfo:"CbmCashBookViewInfo",
      Cbm_CashBookAdd:"CbmCashBookAdd",
      Cbm_CashBookUpdate:"CbmCashBookUpdate",
      Cbm_CashBookUpdateStatus:"CbmCashBookUpdateStatus",
    //Transactions Types
    Cbm_TransactionTypeScreen:"CbmTransactionTypeScreen",
      Cbm_TransactionTypeViewList:"CbmTransactionTypeViewList",
      Cbm_TransactionTypeViewInfo:"CbmTransactionTypeViewInfo",
      Cbm_TransactionTypeAdd:"CbmTransactionTypeAdd",
      Cbm_TransactionTypeUpdate:"CbmTransactionTypeUpdate",
      Cbm_TransactionTypeUpdateStatus:"CbmTransactionTypeUpdateStatus",
    //Payment MethodS
    Cbm_PaymentMethodScreen:"CbmPaymentMethodScreen",
      Cbm_PaymentMethodViewList:"CbmPaymentMethodViewList",
      Cbm_PaymentMethodViewInfo:"CbmPaymentMethodViewInfo",
      Cbm_PaymentMethodAdd:"CbmPaymentMethodAdd",
      Cbm_PaymentMethodUpdate:"CbmPaymentMethodUpdate",
      Cbm_PaymentMethodUpdateStatus:"CbmPaymentMethodUpdateStatus",
    //Party Type
    Cbm_PartyTypeScreen:"CbmPartyTypeScreen",
      Cbm_PartyTypeViewList:"CbmPartyTypeViewList",
      Cbm_PartyTypeViewInfo:"CbmPartyTypeViewInfo",
      Cbm_PartyTypeAdd:"CbmPartyTypeAdd",
      Cbm_PartyTypeUpdate:"CbmPartyTypeUpdate",
      Cbm_PartyTypeUpdateStatus:"CbmPartyTypeUpdateStatus"
  },
  "FlwLookup": {
    Flw_Lookup: 'FlwLookup',
    Workflow_Management: 'WorkflowManagement',
    //FlwStepStatusScreen
    Flw_StepStatusScreen: 'FlwStepStatusScreen',
    Flw_StepStatusViewList: 'FlwStepStatusViewList',
    Flw_StepStatusViewInfo: 'FlwStepStatusViewInfo',
    Flw_StepStatusAdd: 'FlwStepStatusAdd',
    Flw_StepStatusUpdate: 'FlwStepStatusUpdate',
    Flw_StepStatusUpdateStatus: 'FlwStepStatusUpdateStatus',
    //FlwStepStatusConfigurationScreen
    Flw_StepStatusConfigurationScreen: 'FlwStepStatusConfigurationScreen',
    Flw_StepStatusConfigurationViewList: 'FlwStepStatusConfigurationViewList',
    Flw_StepStatusConfigurationViewInfo: 'FlwStepStatusConfigurationViewInfo',
    Flw_StepStatusConfigurationAdd: 'FlwStepStatusConfigurationAdd',
    Flw_StepStatusConfigurationUpdate: 'FlwStepStatusConfigurationUpdate',
    Flw_StepStatusConfigurationUpdateStatus: 'FlwStepStatusConfigurationUpdateStatus',
    //FlwWorkflowScreen
    Flw_WorkflowScreen: 'FlwWorkflowScreen',
    Flw_WorkflowViewList: 'FlwWorkflowViewList',
    Flw_WorkflowViewInfo: 'FlwWorkflowViewInfo',
    Flw_WorkflowAdd: 'FlwWorkflowAdd',
    Flw_WorkflowUpdate: 'FlwWorkflowUpdate',
    Flw_WorkflowUpdateStatus: 'FlwWorkflowUpdateStatus',
  },
  "GamLookup": {
    Gam_Lookup: 'GamLookup',
    Game_Management: 'GameManagement',
    //GamGameScreen
    Gam_GameScreen: 'GamGameScreen',
    Gam_GameViewList: 'GamGameViewList',
    Gam_GameViewInfo: 'GamGameViewInfo',
    Gam_GameAdd: 'GamGameAdd',
    Gam_GameUpdate: 'GamGameUpdate',
    Gam_GameUpdateStatus: 'GamGameUpdateStatus',
    //partner
    Gam_GamePartnerScreen: 'GamGamePartnerScreen',
    Gam_GamePartnerViewList: 'GamGamePartnerViewList',
    Gam_GamePartnerViewInfo: 'GamGamePartnerViewInfo',
    Gam_GamePartnerAdd: 'GamGamePartnerAdd',
    Gam_GamePartnerUpdate: 'GamGamePartnerUpdate',
    Gam_GamePartnerUpdateStatus: 'GamGamePartnerUpdateStatus',
    //partner/tier
    Gam_PartnerTierScreen: 'GamGamePartnerTierScreen',
    Gam_PartnerTierViewList: 'GamPartnerTierViewList',
    Gam_PartnerTierViewInfo: 'GamPartnerTierViewInfo',
    Gam_PartnerTierAdd: 'GamPartnerTierAdd',
    Gam_PartnerTierUpdate: 'GamPartnerTierUpdate',
    Gam_PartnerTierUpdateStatus: 'GamPartnerTierUpdateStatus',
    //GamGameItem
    GamGameItemScreen: 'GamGameItemScreen',
    GamGameItemViewList: 'GamGameItemViewList',
    GamGameItemViewInfo: 'GamGameItemViewInfo',
    GamGameItemAdd: 'GamGameItemAdd',
    GamGameItemUpdate: 'GamGameItemUpdate',
    GamGameItemUpdateStatus: 'GamGameItemUpdateStatus',
    //GamCouponScreen
  },
  "DshLookup": {
    "Dsh_Lookup": "DshLookup",
    "Dashboard_Management": "DashboardManagement",
    //Dynamic Dashboard List
    "Dsh_DashboardsListScreen": "DshDashboardsListScreen",
    "Dsh_DashboardsListViewList": "DshDashboardsListViewList",
    "Dsh_DashboardsListViewInfo": "DshDashboardsListViewInfo",
    "Dsh_DashboardsListAdd": "DshDashboardsListAdd",
    "Dsh_DashboardsListUpdate": "DshDashboardsListUpdate",
    "Dsh_DashboardsListUpdateStatus": "DshDashboardsListUpdateStatus",
    //Data Source Catalog
    "Dsh_DataSourceCatalogScreen": "DshDataSourceCatalogScreen",
    "Dsh_DataSourceCatalogViewList": "DshDataSourceCatalogViewList",
    "Dsh_DataSourceCatalogViewInfo": "DshDataSourceCatalogViewInfo",
    "Dsh_DataSourceCatalogAdd": "DshDataSourceCatalogAdd",
    "Dsh_DataSourceCatalogUpdate": "DshDataSourceCatalogUpdate",
    "Dsh_DataSourceCatalogUpdateStatus": "DshDataSourceCatalogUpdateStatus",
    //Widget Types
    "Dsh_DashboardWidgetTypesScreen": "DshDashboardWidgetTypesScreen",
    "Dsh_DashboardWidgetTypesViewList": "DshDashboardWidgetTypesViewList",
    "Dsh_DashboardWidgetTypesViewInfo": "DshDashboardWidgetTypesViewInfo",
    "Dsh_DashboardWidgetTypesAdd": "DshDashboardWidgetTypesAdd",
    "Dsh_DashboardWidgetTypesUpdate": "DshDashboardWidgetTypesUpdate",
    "Dsh_DashboardWidgetTypesUpdateStatus": "DshDashboardWidgetTypesUpdateStatus",
    //Dashboards Themes
    "Dsh_ThemesScreen": "DshThemesScreen",
    "Dsh_ThemesViewList": "DshThemesViewList",
    "Dsh_ThemesViewInfo": "DshThemesViewInfo",
    "Dsh_ThemesAdd": "DshThemesAdd",
    "Dsh_ThemesUpdate": "DshThemesUpdate",
    "Dsh_ThemesUpdateStatus": "DshThemesUpdateStatus",

    "Dashboards_Management": "Dashboards",
    //DashboardScreen
    "DashboardScreen": "DashboardScreen",
    "DashboardViewList": "DashboardViewList",
    "DashboardViewInfo": "DashboardViewInfo",
    "DashboardAdd": "DashboardAdd",
    "DashboardUpdate": "DashboardUpdate",
    "DashboardUpdateStatus": "DashboardUpdateStatus",
    //DashboardTicketScreen
    "DashboardTicketScreen": "DashboardTicketScreen",
    "DashboardTicketViewList": "DashboardTicketViewList",
    "DashboardTicketViewInfo": "DashboardTicketViewInfo",
    "DashboardTicketAdd": "DashboardTicketAdd",
    "DashboardTicketUpdate": "DashboardTicketUpdate",
    "DashboardTicketUpdateStatus": "DashboardTicketUpdateStatus",
    //DashboardActivityScreen
    "DashboardActivityScreen": "DashboardActivityScreen",
    "DashboardActivityViewList": "DashboardActivityViewList",
    "DashboardActivityViewInfo": "DashboardActivityViewInfo",
    "DashboardActivityAdd": "DashboardActivityAdd",
    "DashboardActivityUpdate": "DashboardActivityUpdate",
    "DashboardActivityUpdateStatus": "DashboardActivityUpdateStatus",
    //IotHydrostaticDashboardScreen
    "IotHydrostaticDashboardScreen": "IotHydrostaticDashboardScreen",
    "IotHydrostaticDashboardViewList": "IotHydrostaticDashboardViewList",
    "IotHydrostaticDashboardViewInfo": "IotHydrostaticDashboardViewInfo",
    "IotHydrostaticDashboardAdd": "IotHydrostaticDashboardAdd",
    "IotHydrostaticDashboardUpdate": "IotHydrostaticDashboardUpdate",
    "IotHydrostaticDashboardUpdateStatus": "IotHydrostaticDashboardUpdateStatus"
  },
  "RepLookup": {
    "Rep_Lookup": "RepLookup",
    "Reports_Management": "Reports",
    "EvlResultsReportScreen": "EvlResultsReportScreen",
    "ActivityReportScreen": "ActivityReportScreen",
    "TicketReportScreen": "TicketReportScreen",
    "CbmStatementAccountReportScreen": "CbmStatementAccountReportScreen",
    "TimeSheetReportScreen": "TimeSheetReportScreen",
    "MonthlyTimeSheetScreen": "MonthlyTimeSheetScreen",
    "ActivityTypeReportScreen": "ActivityTypeReportScreen",
  },
  "TktLookup": {
    Tkt_Lookup: 'TktLookup',
    Activity_Management: 'ActivityManagement',

    // Activity 
    Tkt_ActivityScreen: "TktActivityScreen",
    Tkt_ActivityViewList: "TktActivityViewList",
    Tkt_ActivityViewInfo: "TktActivityViewInfo",
    Tkt_ActivityAdd: "TktActivityAdd",
    Tkt_ActivityUpdate: "TktActivityUpdate",
    Tkt_ActivityUpdateStatus: "TktActivityUpdateStatus",

    // Activity Type
    Tkt_ActivityTypeScreen: "TktActivityTypeScreen",
    Tkt_ActivityTypeViewList: "TktActivityTypeViewList",
    Tkt_ActivityTypeViewInfo: "TktActivityTypeViewInfo",
    Tkt_ActivityTypeAdd: "TktActivityTypeAdd",
    Tkt_ActivityTypeUpdate: "TktActivityTypeUpdate",
    Tkt_ActivityTypeUpdateStatus: "TktActivityTypeUpdateStatus",

    // Activity Type Tag 
    Tkt_ActivityTypeTagScreen: "TktActivityTypeTagScreen",
    Tkt_ActivityTypeTagViewList: "TktActivityTypeTagViewList",
    Tkt_ActivityTypeTagViewInfo: "TktActivityTypeTagViewInfo",
    Tkt_ActivityTypeTagAdd: "TktActivityTypeTagAdd",
    Tkt_ActivityTypeTagUpdate: "TktActivityTypeTagUpdate",
    Tkt_ActivityTypeTagUpdateStatus: "TktActivityTypeTagUpdateStatus",

    //Activity List Screen
    Tkt_ActivityListScreen:"TktActivityListScreen",
    Tkt_ActivityListViewList:"TktActivityListViewList",
    Tkt_ActivityListViewInfo:"TktActivityListViewInfo",
    Tkt_ActivityListAdd:"TktActivityListAdd",
    Tkt_ActivityListUpdate:"TktActivityListUpdate",
    Tkt_ActivityListUpdateStatus:"TktActivityListUpdateStatus",
    Tkt_ActivityListViewAllList:"TktActivityListViewAllList",

    Task_Management: 'TaskManagement',

    // Task Group
    Tkt_TaskGroupScreen: "TktTaskGroupScreen",
    Tkt_TaskGroupViewList: "TktTaskGroupViewList",
    Tkt_TaskGroupViewInfo: "TktTaskGroupViewInfo",
    Tkt_TaskGroupAdd: "TktTaskGroupAdd",
    Tkt_TaskGroupUpdate: "TktTaskGroupUpdate",
    Tkt_TaskGroupUpdateStatus: "TktTaskGroupUpdateStatus",

    // Task Status
    Tkt_TaskStatusScreen: "TktTaskStatusScreen",
    Tkt_TaskStatusViewList: "TktTaskStatusViewList",
    Tkt_TaskStatusViewInfo: "TktTaskStatusViewInfo",
    Tkt_TaskStatusAdd: "TktTaskStatusAdd",
    Tkt_TaskStatusUpdate: "TktTaskStatusUpdate",
    Tkt_TaskStatusUpdateStatus: "TktTaskStatusUpdateStatus",

    // Task Status Collection
    Tkt_TaskStatusCollectionScreen: "TktTaskStatusCollectionScreen",
    Tkt_TaskStatusCollectionViewList: "TktTaskStatusCollectionViewList",
    Tkt_TaskStatusCollectionViewInfo: "TktTaskStatusCollectionViewInfo",
    Tkt_TaskStatusCollectionAdd: "TktTaskStatusCollectionAdd",
    Tkt_TaskStatusCollectionUpdate: "TktTaskStatusCollectionUpdate",
    Tkt_TaskStatusCollectionUpdateStatus: "TktTaskStatusCollectionUpdateStatus",

    // Task Type
    Tkt_TaskTypeScreen: "TktTaskTypeScreen",
    Tkt_TaskTypeViewList: "TktTaskTypeViewList",
    Tkt_TaskTypeViewInfo: "TktTaskTypeViewInfo",
    Tkt_TaskTypeAdd: "TktTaskTypeAdd",
    Tkt_TaskTypeUpdate: "TktTaskTypeUpdate",
    Tkt_TaskTypeUpdateStatus: "TktTaskTypeUpdateStatus",

    // Task Type Additional Data Type
    Tkt_TaskTypeAdditionalDataTypeScreen: "TktTaskTypeAdditionalDataTypeScreen",
    Tkt_TaskTypeAdditionalDataTypeViewList: "TktTaskTypeAdditionalDataTypeViewList",
    Tkt_TaskTypeAdditionalDataTypeViewInfo: "TktTaskTypeAdditionalDataTypeViewInfo",
    Tkt_TaskTypeAdditionalDataTypeAdd: "TktTaskTypeAdditionalDataTypeAdd",
    Tkt_TaskTypeAdditionalDataTypeUpdate: "TktTaskTypeAdditionalDataTypeUpdate",
    Tkt_TaskTypeAdditionalDataTypeUpdateStatus: "TktTaskTypeAdditionalDataTypeUpdateStatus",

    Ticket_Management: 'TicketManagement',

    // Ticket
    Tkt_TicketScreen: "TktTicketScreen",
    Tkt_TicketViewList: "TktTicketViewList",
    Tkt_TicketViewInfo: "TktTicketViewInfo",
    Tkt_TicketAdd: "TktTicketAdd",
    Tkt_TicketUpdate: "TktTicketUpdate",
    Tkt_TicketUpdateStatus: "TktTicketUpdateStatus",
    Tkt_TicketListViewAllList:"TktTicketListViewAllList",

    // Ticket Additional Data
    Tkt_TicketAdditionalDataScreen: "TktTicketAdditionalDataScreen",
    Tkt_TicketAdditionalDataViewList: "TktTicketAdditionalDataViewList",
    Tkt_TicketAdditionalDataViewInfo: "TktTicketAdditionalDataViewInfo",
    Tkt_TicketAdditionalDataAdd: "TktTicketAdditionalDataAdd",
    Tkt_TicketAdditionalDataUpdate: "TktTicketAdditionalDataUpdate",
    Tkt_TicketAdditionalDataUpdateStatus: "TktTicketAdditionalDataUpdateStatus",

    TicketType_Management: 'TicketTypeManagement',

    // Ticket Type
    Tkt_TicketTypeScreen: "TktTicketTypeScreen",
    Tkt_TicketTypeViewList: "TktTicketTypeViewList",
    Tkt_TicketTypeViewInfo: "TktTicketTypeViewInfo",
    Tkt_TicketTypeAdd: "TktTicketTypeAdd",
    Tkt_TicketTypeUpdate: "TktTicketTypeUpdate",
    Tkt_TicketTypeUpdateStatus: "TktTicketTypeUpdateStatus",

    // Ticket Type Additional Data Type
    Tkt_TicketTypeAdditionalDataTypeScreen: "TktTicketTypeAdditionalDataTypeScreen",
    Tkt_TicketTypeAdditionalDataTypeViewList: "TktTicketTypeAdditionalDataTypeViewList",
    Tkt_TicketTypeAdditionalDataTypeViewInfo: "TktTicketTypeAdditionalDataTypeViewInfo",
    Tkt_TicketTypeAdditionalDataTypeAdd: "TktTicketTypeAdditionalDataTypeAdd",
    Tkt_TicketTypeAdditionalDataTypeUpdate: "TktTicketTypeAdditionalDataTypeUpdate",
    Tkt_TicketTypeAdditionalDataTypeUpdateStatus: "TktTicketTypeAdditionalDataTypeUpdateStatus",

    // Ticket Type Linked Object
    Tkt_TicketTypeLinkedObjectScreen: "TktTicketTypeLinkedObjectScreen",
    Tkt_TicketTypeLinkedObjectViewList: "TktTicketTypeLinkedObjectViewList",
    Tkt_TicketTypeLinkedObjectViewInfo: "TktTicketTypeLinkedObjectViewInfo",
    Tkt_TicketTypeLinkedObjectAdd: "TktTicketTypeLinkedObjectAdd",
    Tkt_TicketTypeLinkedObjectUpdate: "TktTicketTypeLinkedObjectUpdate",
    Tkt_TicketTypeLinkedObjectUpdateStatus: "TktTicketTypeLinkedObjectUpdateStatus",

    // Ticket Type Option
    Tkt_TicketTypeOptionScreen: "TktTicketTypeOptionScreen",
    Tkt_TicketTypeOptionViewList: "TktTicketTypeOptionViewList",
    Tkt_TicketTypeOptionViewInfo: "TktTicketTypeOptionViewInfo",
    Tkt_TicketTypeOptionAdd: "TktTicketTypeOptionAdd",
    Tkt_TicketTypeOptionUpdate: "TktTicketTypeOptionUpdate",
    Tkt_TicketTypeOptionUpdateStatus: "TktTicketTypeOptionUpdateStatus",

    TicketOption_Management: 'TicketOptionManagement',

    // Ticket Option
    Tkt_TicketOptionScreen: "TktTicketOptionScreen",
    Tkt_TicketOptionViewList: "TktTicketOptionViewList",
    Tkt_TicketOptionViewInfo: "TktTicketOptionViewInfo",
    Tkt_TicketOptionAdd: "TktTicketOptionAdd",
    Tkt_TicketOptionUpdate: "TktTicketOptionUpdate",
    Tkt_TicketOptionUpdateStatus: "TktTicketOptionUpdateStatus",

    // Ticket Option Collection
    Tkt_TicketOptionCollectionScreen: "TktTicketOptionCollectionScreen",
    Tkt_TicketOptionCollectionViewList: "TktTicketOptionCollectionViewList",
    Tkt_TicketOptionCollectionViewInfo: "TktTicketOptionCollectionViewInfo",
    Tkt_TicketOptionCollectionAdd: "TktTicketOptionCollectionAdd",
    Tkt_TicketOptionCollectionUpdate: "TktTicketOptionCollectionUpdate",
    Tkt_TicketOptionCollectionUpdateStatus: "TktTicketOptionCollectionUpdateStatus",

    // Ticket Option Entry
    Tkt_TicketOptionEntryScreen: "TktTicketOptionEntryScreen",
    Tkt_TicketOptionEntryViewList: "TktTicketOptionEntryViewList",
    Tkt_TicketOptionEntryViewInfo: "TktTicketOptionEntryViewInfo",
    Tkt_TicketOptionEntryAdd: "TktTicketOptionEntryAdd",
    Tkt_TicketOptionEntryUpdate: "TktTicketOptionEntryUpdate",
    Tkt_TicketOptionEntryUpdateStatus: "TktTicketOptionEntryUpdateStatus",

    Link_Management: 'LinkManagement',

    // Linked Objects
    Tkt_LinkedObjectsScreen: "TktLinkedObjectsScreen",
    Tkt_LinkedObjectsViewList: "TktLinkedObjectsViewList",
    Tkt_LinkedObjectsViewInfo: "TktLinkedObjectsViewInfo",
    Tkt_LinkedObjectsAdd: "TktLinkedObjectsAdd",
    Tkt_LinkedObjectsUpdate: "TktLinkedObjectsUpdate",
    Tkt_LinkedObjectsUpdateStatus: "TktLinkedObjectsUpdateStatus",

    General_Management: 'GeneralManagement',
    
    // Priority
    Tkt_PriorityScreen: "TktPriorityScreen",
    Tkt_PriorityViewList: "TktPriorityViewList",
    Tkt_PriorityViewInfo: "TktPriorityViewInfo",
    Tkt_PriorityAdd: "TktPriorityAdd",
    Tkt_PriorityUpdate: "TktPriorityUpdate",
    Tkt_PriorityUpdateStatus: "TktPriorityUpdateStatus",

    // Tag
    Tkt_TagScreen: "TktTagScreen",
    Tkt_TagViewList: "TktTagViewList",
    Tkt_TagViewInfo: "TktTagViewInfo",
    Tkt_TagAdd: "TktTagAdd",
    Tkt_TagUpdate: "TktTagUpdate",
    Tkt_TagUpdateStatus: "TktTagUpdateStatus",
  }
}

